export const pokedexIDs = [
    "0001",
    "0002",
    "0003",
    "0004",
    "0005",
    "0006",
    "0007",
    "0008",
    "0009",
    "0010",
    "0011",
    "0012",
    "0013",
    "0014",
    "0015",
    "0016",
    "0017",
    "0018",
    "0019",
    "0020",
    "0021",
    "0022",
    "0023",
    "0024",
    "0025",
    "0026",
    "0027",
    "0028",
    "0029",
    "0030",
    "0031",
    "0032",
    "0033",
    "0034",
    "0035",
    "0036",
    "0037",
    "0038",
    "0039",
    "0040",
    "0041",
    "0042",
    "0043",
    "0044",
    "0045",
    "0046",
    "0047",
    "0048",
    "0049",
    "0050",
    "0051",
    "0052",
    "0053",
    "0054",
    "0055",
    "0056",
    "0057",
    "0058",
    "0059",
    "0060",
    "0061",
    "0062",
    "0063",
    "0064",
    "0065",
    "0066",
    "0067",
    "0068",
    "0069",
    "0070",
    "0071",
    "0072",
    "0073",
    "0074",
    "0075",
    "0076",
    "0077",
    "0078",
    "0079",
    "0080",
    "0081",
    "0082",
    "0083",
    "0084",
    "0085",
    "0086",
    "0087",
    "0088",
    "0089",
    "0090",
    "0091",
    "0092",
    "0093",
    "0094",
    "0095",
    "0096",
    "0097",
    "0098",
    "0099",
    "0100",
    "0101",
    "0102",
    "0103",
    "0104",
    "0105",
    "0106",
    "0107",
    "0108",
    "0109",
    "0110",
    "0111",
    "0112",
    "0113",
    "0114",
    "0115",
    "0116",
    "0117",
    "0118",
    "0119",
    "0120",
    "0121",
    "0122",
    "0123",
    "0124",
    "0125",
    "0126",
    "0127",
    "0128",
    "0129",
    "0130",
    "0131",
    "0132",
    "0133",
    "0134",
    "0135",
    "0136",
    "0137",
    "0138",
    "0139",
    "0140",
    "0141",
    "0142",
    "0143",
    "0144",
    "0145",
    "0146",
    "0147",
    "0148",
    "0149",
    "0150",
    "0151",
    "0152",
    "0153",
    "0154",
    "0155",
    "0156",
    "0157",
    "0158",
    "0159",
    "0160",
    "0161",
    "0162",
    "0163",
    "0164",
    "0165",
    "0166",
    "0167",
    "0168",
    "0169",
    "0170",
    "0171",
    "0172",
    "0173",
    "0174",
    "0175",
    "0176",
    "0177",
    "0178",
    "0179",
    "0180",
    "0181",
    "0182",
    "0183",
    "0184",
    "0185",
    "0186",
    "0187",
    "0188",
    "0189",
    "0190",
    "0191",
    "0192",
    "0193",
    "0194",
    "0195",
    "0196",
    "0197",
    "0198",
    "0199",
    "0200",
    "0201A",
    "0202",
    "0203",
    "0204",
    "0205",
    "0206",
    "0207",
    "0208",
    "0209",
    "0210",
    "0211",
    "0212",
    "0213",
    "0214",
    "0215",
    "0216",
    "0217",
    "0218",
    "0219",
    "0220",
    "0221",
    "0222",
    "0223",
    "0224",
    "0225",
    "0226",
    "0227",
    "0228",
    "0229",
    "0230",
    "0231",
    "0232",
    "0233",
    "0234",
    "0235",
    "0236",
    "0237",
    "0238",
    "0239",
    "0240",
    "0241",
    "0242",
    "0243",
    "0244",
    "0245",
    "0246",
    "0247",
    "0248",
    "0249",
    "0250",
    "0251",
    "0252",
    "0253",
    "0254",
    "0255",
    "0256",
    "0257",
    "0258",
    "0259",
    "0260",
    "0261",
    "0262",
    "0263",
    "0264",
    "0265",
    "0266",
    "0267",
    "0268",
    "0269",
    "0270",
    "0271",
    "0272",
    "0273",
    "0274",
    "0275",
    "0276",
    "0277",
    "0278",
    "0279",
    "0280",
    "0281",
    "0282",
    "0283",
    "0284",
    "0285",
    "0286",
    "0287",
    "0288",
    "0289",
    "0290",
    "0291",
    "0292",
    "0293",
    "0294",
    "0295",
    "0296",
    "0297",
    "0298",
    "0299",
    "0300",
    "0301",
    "0302",
    "0303",
    "0304",
    "0305",
    "0306",
    "0307",
    "0308",
    "0309",
    "0310",
    "0311",
    "0312",
    "0313",
    "0314",
    "0315",
    "0316",
    "0317",
    "0318",
    "0319",
    "0320",
    "0321",
    "0322",
    "0323",
    "0324",
    "0325",
    "0326",
    "0327",
    "0328",
    "0329",
    "0330",
    "0331",
    "0332",
    "0333",
    "0334",
    "0335",
    "0336",
    "0337",
    "0338",
    "0339",
    "0340",
    "0341",
    "0342",
    "0343",
    "0344",
    "0345",
    "0346",
    "0347",
    "0348",
    "0349",
    "0350",
    "0351",
    "0352",
    "0353",
    "0354",
    "0355",
    "0356",
    "0357",
    "0358",
    "0359",
    "0360",
    "0361",
    "0362",
    "0363",
    "0364",
    "0365",
    "0366",
    "0367",
    "0368",
    "0369",
    "0370",
    "0371",
    "0372",
    "0373",
    "0374",
    "0375",
    "0376",
    "0377",
    "0378",
    "0379",
    "0380",
    "0381",
    "0382",
    "0383",
    "0384",
    "0385",
    "0386",
    "0387",
    "0388",
    "0389",
    "0390",
    "0391",
    "0392",
    "0393",
    "0394",
    "0395",
    "0396",
    "0397",
    "0398",
    "0399",
    "0400",
    "0401",
    "0402",
    "0403",
    "0404",
    "0405",
    "0406",
    "0407",
    "0408",
    "0409",
    "0410",
    "0411",
    "0412P",
    "0413P",
    "0414",
    "0415",
    "0416",
    "0417",
    "0418",
    "0419",
    "0420",
    "0421E",
    "0422Oc",
    "0423Oc",
    "0424",
    "0425",
    "0426",
    "0427",
    "0428",
    "0429",
    "0430",
    "0431",
    "0432",
    "0433",
    "0434",
    "0435",
    "0436",
    "0437",
    "0438",
    "0439",
    "0440",
    "0441",
    "0442",
    "0443",
    "0444",
    "0445",
    "0446",
    "0447",
    "0448",
    "0449",
    "0450",
    "0451",
    "0452",
    "0453",
    "0454",
    "0455",
    "0456",
    "0457",
    "0458",
    "0459",
    "0460",
    "0461",
    "0462",
    "0463",
    "0464",
    "0465",
    "0466",
    "0467",
    "0468",
    "0469",
    "0470",
    "0471",
    "0472",
    "0473",
    "0474",
    "0475",
    "0476",
    "0477",
    "0478",
    "0479",
    "0480",
    "0481",
    "0482",
    "0483",
    "0484",
    "0485",
    "0486",
    "0487",
    "0488",
    "0489",
    "0490",
    "0491",
    "0492T",
    "0493",
    "0494",
    "0495",
    "0496",
    "0497",
    "0498",
    "0499",
    "0500",
    "0501",
    "0502",
    "0503",
    "0504",
    "0505",
    "0506",
    "0507",
    "0508",
    "0509",
    "0510",
    "0511",
    "0512",
    "0513",
    "0514",
    "0515",
    "0516",
    "0517",
    "0518",
    "0519",
    "0520",
    "0521M",
    "0522",
    "0523",
    "0524",
    "0525",
    "0526",
    "0527",
    "0528",
    "0529",
    "0530",
    "0531",
    "0532",
    "0533",
    "0534",
    "0535",
    "0536",
    "0537",
    "0538",
    "0539",
    "0540",
    "0541",
    "0542",
    "0543",
    "0544",
    "0545",
    "0546",
    "0547",
    "0548",
    "0549",
    "0550R",
    "0551",
    "0552",
    "0553",
    "0554",
    "0555N",
    "0556",
    "0557",
    "0558",
    "0559",
    "0560",
    "0561",
    "0562",
    "0563",
    "0564",
    "0565",
    "0566",
    "0567",
    "0568",
    "0569",
    "0570",
    "0571",
    "0572",
    "0573",
    "0574",
    "0575",
    "0576",
    "0577",
    "0578",
    "0579",
    "0580",
    "0581",
    "0582",
    "0583",
    "0584",
    "0585P",
    "0586P",
    "0587",
    "0588",
    "0589",
    "0590",
    "0591",
    "0592M",
    "0593M",
    "0594",
    "0595",
    "0596",
    "0597",
    "0598",
    "0599",
    "0600",
    "0601",
    "0602",
    "0603",
    "0604",
    "0605",
    "0606",
    "0607",
    "0608",
    "0609",
    "0610",
    "0611",
    "0612",
    "0613",
    "0614",
    "0615",
    "0616",
    "0617",
    "0618",
    "0619",
    "0620",
    "0621",
    "0622",
    "0623",
    "0624",
    "0625",
    "0626",
    "0627",
    "0628",
    "0629",
    "0630",
    "0631",
    "0632",
    "0633",
    "0634",
    "0635",
    "0636",
    "0637",
    "0638",
    "0639",
    "0640",
    "0641A",
    "0642A",
    "0643",
    "0644",
    "0645A",
    "0646",
    "0647",
    "0648C",
    "0649",
    "0650",
    "0651",
    "0652",
    "0653",
    "0654",
    "0655",
    "0656",
    "0657",
    "0658",
    "0659",
    "0660",
    "0661",
    "0662",
    "0663",
    "0664",
    "0665",
    "0666Flo",
    "0667",
    "0668M",
    "0669R",
    "0670R",
    "0671R",
    "0672",
    "0673",
    "0674",
    "0675",
    "0676",
    "0677",
    "0678M",
    "0679",
    "0680",
    "0681P",
    "0682",
    "0683",
    "0684",
    "0685",
    "0686",
    "0687",
    "0688",
    "0689",
    "0690",
    "0691",
    "0692",
    "0693",
    "0694",
    "0695",
    "0696",
    "0697",
    "0698",
    "0699",
    "0700",
    "0701",
    "0702",
    "0703",
    "0704",
    "0705",
    "0706",
    "0707",
    "0708",
    "0709",
    "0710",
    "0711",
    "0712",
    "0713",
    "0714",
    "0715",
    "0716",
    "0717",
    "0718F50",
    "0719",
    "0720E",
    "0721",
    "0722",
    "0723",
    "0724",
    "0725",
    "0726",
    "0727",
    "0728",
    "0729",
    "0730",
    "0731",
    "0732",
    "0733",
    "0734",
    "0735",
    "0736",
    "0737",
    "0738",
    "0739",
    "0740",
    "0741F",
    "0742",
    "0743",
    "0744",
    "0745D",
    "0746S",
    "0747",
    "0748",
    "0749",
    "0750",
    "0751",
    "0752",
    "0753",
    "0754",
    "0755",
    "0756",
    "0757",
    "0758",
    "0759",
    "0760",
    "0761",
    "0762",
    "0763",
    "0764",
    "0765",
    "0766",
    "0767",
    "0768",
    "0769",
    "0770",
    "0771",
    "0772",
    "0773Nor",
    "0774",
    "0775",
    "0776",
    "0777",
    "0778",
    "0779",
    "0780",
    "0781",
    "0782",
    "0783",
    "0784",
    "0785",
    "0786",
    "0787",
    "0788",
    "0789",
    "0790",
    "0791",
    "0792",
    "0793",
    "0794",
    "0795",
    "0796",
    "0797",
    "0798",
    "0799",
    "0800",
    "0801",
    "0802",
    "0803",
    "0804",
    "0805",
    "0806",
    "0807",
    "0808",
    "0809",
    "0810",
    "0811",
    "0812",
    "0813",
    "0814",
    "0815",
    "0816",
    "0817",
    "0818",
    "0819",
    "0820",
    "0821",
    "0822",
    "0823",
    "0824",
    "0825",
    "0826",
    "0827",
    "0828",
    "0829",
    "0830",
    "0831",
    "0832",
    "0833",
    "0834",
    "0835",
    "0836",
    "0837",
    "0838",
    "0839",
    "0840",
    "0841",
    "0842",
    "0843",
    "0844",
    "0845",
    "0846",
    "0847",
    "0848",
    "0849A",
    "0849A",
    "0850",
    "0851",
    "0852",
    "0853",
    "0854A",
    "0855A",
    "0856",
    "0857",
    "0858",
    "0859",
    "0860",
    "0861",
    "0862",
    "0863",
    "0864",
    "0865",
    "0866",
    "0867",
    "0868",
    "0869VanFra",
    "0870",
    "0871",
    "0872",
    "0873",
    "0874",
    "0875G",
    "0876M",
    "0877R",
    "0878",
    "0879",
    "0880",
    "0881",
    "0882",
    "0883",
    "0884",
    "0885",
    "0886",
    "0887",
    "0888ES",
    "0889BS",
    "0890",
    "0891",
    "0892PF",
    "0893",
    "0894",
    "0895",
    "0896",
    "0897",
    "0898",
    "0899",
    "0900",
    "0901",
    "0902M",
    "0903",
    "0904",
    "0905A",
    "0906",
    "0907",
    "0908",
    "0909",
    "0910",
    "0911",
    "0912",
    "0913",
    "0914",
    "0915",
    "0916M",
    "0917",
    "0918",
    "0919",
    "0920",
    "0921",
    "0922",
    "0923",
    "0924",
    "0925F4",
    "0926",
    "0927",
    "0928",
    "0929",
    "0930",
    "0931V",
    "0932",
    "0933",
    "0934",
    "0935",
    "0936",
    "0937",
    "0938",
    "0939",
    "0940",
    "0941",
    "0942",
    "0943",
    "0944",
    "0945",
    "0946",
    "0947",
    "0948",
    "0949",
    "0950",
    "0951",
    "0952",
    "0953",
    "0954",
    "0955",
    "0956",
    "0957",
    "0958",
    "0959",
    "0960",
    "0961",
    "0962",
    "0963",
    "0964S",
    "0965",
    "0966",
    "0967",
    "0968",
    "0969",
    "0970",
    "0971",
    "0972",
    "0973",
    "0974",
    "0975",
    "0976",
    "0977",
    "0978C",
    "0979",
    "0980",
    "0981",
    "0982F2",
    "0983",
    "0984",
    "0985",
    "0986",
    "0987",
    "0988",
    "0989",
    "0990",
    "0991",
    "0992",
    "0993",
    "0994",
    "0995",
    "0996",
    "0997",
    "0998",
    "0999C",
    "1000",
    "1001",
    "1002",
    "1003",
    "1004",
    "1005",
    "1006",
    "1007",
    "1008",
    "1009",
    "1010",
    "1011",
    "1012O",
    "1013E",
    "1014",
    "1015",
    "1016",
    "1017Tur",
    "1018",
    "1019",
    "1020",
    "1021",
    "1022",
    "1023",
    "1024T",
    "1025"
]

export const gen1IDs = [
    "0001",
    "0002",
    "0003",
    "0004",
    "0005",
    "0006",
    "0007",
    "0008",
    "0009",
    "0010",
    "0011",
    "0012",
    "0013",
    "0014",
    "0015",
    "0016",
    "0017",
    "0018",
    "0019",
    "0020",
    "0021",
    "0022",
    "0023",
    "0024",
    "0025",
    "0026",
    "0027",
    "0028",
    "0029",
    "0030",
    "0031",
    "0032",
    "0033",
    "0034",
    "0035",
    "0036",
    "0037",
    "0038",
    "0039",
    "0040",
    "0041",
    "0042",
    "0043",
    "0044",
    "0045",
    "0046",
    "0047",
    "0048",
    "0049",
    "0050",
    "0051",
    "0052",
    "0053",
    "0054",
    "0055",
    "0056",
    "0057",
    "0058",
    "0059",
    "0060",
    "0061",
    "0062",
    "0063",
    "0064",
    "0065",
    "0066",
    "0067",
    "0068",
    "0069",
    "0070",
    "0071",
    "0072",
    "0073",
    "0074",
    "0075",
    "0076",
    "0077",
    "0078",
    "0079",
    "0080",
    "0081",
    "0082",
    "0083",
    "0084",
    "0085",
    "0086",
    "0087",
    "0088",
    "0089",
    "0090",
    "0091",
    "0092",
    "0093",
    "0094",
    "0095",
    "0096",
    "0097",
    "0098",
    "0099",
    "0100",
    "0101",
    "0102",
    "0103",
    "0104",
    "0105",
    "0106",
    "0107",
    "0108",
    "0109",
    "0110",
    "0111",
    "0112",
    "0113",
    "0114",
    "0115",
    "0116",
    "0117",
    "0118",
    "0119",
    "0120",
    "0121",
    "0122",
    "0123",
    "0124",
    "0125",
    "0126",
    "0127",
    "0128",
    "0129",
    "0130",
    "0131",
    "0132",
    "0133",
    "0134",
    "0135",
    "0136",
    "0137",
    "0138",
    "0139",
    "0140",
    "0141",
    "0142",
    "0143",
    "0144",
    "0145",
    "0146",
    "0147",
    "0148",
    "0149",
    "0150",
    "0151"
]

export const gen2IDs = [
    "0152",
    "0153",
    "0154",
    "0155",
    "0156",
    "0157",
    "0158",
    "0159",
    "0160",
    "0161",
    "0162",
    "0163",
    "0164",
    "0165",
    "0166",
    "0167",
    "0168",
    "0169",
    "0170",
    "0171",
    "0172",
    "0173",
    "0174",
    "0175",
    "0176",
    "0177",
    "0178",
    "0179",
    "0180",
    "0181",
    "0182",
    "0183",
    "0184",
    "0185",
    "0186",
    "0187",
    "0188",
    "0189",
    "0190",
    "0191",
    "0192",
    "0193",
    "0194",
    "0195",
    "0196",
    "0197",
    "0198",
    "0199",
    "0200",
    "0201A",
    "0202",
    "0203",
    "0204",
    "0205",
    "0206",
    "0207",
    "0208",
    "0209",
    "0210",
    "0211",
    "0212",
    "0213",
    "0214",
    "0215",
    "0216",
    "0217",
    "0218",
    "0219",
    "0220",
    "0221",
    "0222",
    "0223",
    "0224",
    "0225",
    "0226",
    "0227",
    "0228",
    "0229",
    "0230",
    "0231",
    "0232",
    "0233",
    "0234",
    "0235",
    "0236",
    "0237",
    "0238",
    "0239",
    "0240",
    "0241",
    "0242",
    "0243",
    "0244",
    "0245",
    "0246",
    "0247",
    "0248",
    "0249",
    "0250",
    "0251"
]

export const gen3IDs = [
    "0201PE",
    "0201PI",
    "0252",
    "0253",
    "0254",
    "0255",
    "0256",
    "0257",
    "0258",
    "0259",
    "0260",
    "0261",
    "0262",
    "0263",
    "0264",
    "0265",
    "0266",
    "0267",
    "0268",
    "0269",
    "0270",
    "0271",
    "0272",
    "0273",
    "0274",
    "0275",
    "0276",
    "0277",
    "0278",
    "0279",
    "0280",
    "0281",
    "0282",
    "0283",
    "0284",
    "0285",
    "0286",
    "0287",
    "0288",
    "0289",
    "0290",
    "0291",
    "0292",
    "0293",
    "0294",
    "0295",
    "0296",
    "0297",
    "0298",
    "0299",
    "0300",
    "0301",
    "0302",
    "0303",
    "0304",
    "0305",
    "0306",
    "0307",
    "0308",
    "0309",
    "0310",
    "0311",
    "0312",
    "0313",
    "0314",
    "0315",
    "0316",
    "0317",
    "0318",
    "0319",
    "0320",
    "0321",
    "0322",
    "0323",
    "0324",
    "0325",
    "0326",
    "0327",
    "0328",
    "0329",
    "0330",
    "0331",
    "0332",
    "0333",
    "0334",
    "0335",
    "0336",
    "0337",
    "0338",
    "0339",
    "0340",
    "0341",
    "0342",
    "0343",
    "0344",
    "0345",
    "0346",
    "0347",
    "0348",
    "0349",
    "0350",
    "0351",
    "0351S",
    "0351P",
    "0351B",
    "0352",
    "0353",
    "0354",
    "0355",
    "0356",
    "0357",
    "0358",
    "0359",
    "0360",
    "0361",
    "0362",
    "0363",
    "0364",
    "0365",
    "0366",
    "0367",
    "0368",
    "0369",
    "0370",
    "0371",
    "0372",
    "0373",
    "0374",
    "0375",
    "0376",
    "0377",
    "0378",
    "0379",
    "0380",
    "0381",
    "0382",
    "0383",
    "0384",
    "0385",
    "0386",
    "0386A",
    "0386D",
    "0386V"
]

export const gen4IDs = [
    "0172T",
    "0387",
    "0388",
    "0389",
    "0390",
    "0391",
    "0392",
    "0393",
    "0394",
    "0395",
    "0396",
    "0397",
    "0398",
    "0399",
    "0400",
    "0401",
    "0402",
    "0403",
    "0404",
    "0405",
    "0406",
    "0407",
    "0408",
    "0409",
    "0410",
    "0411",
    "0412P",
    "0412S",
    "0412D",
    "0413P",
    "0413S",
    "0413D",
    "0414",
    "0415",
    "0416",
    "0417",
    "0418",
    "0419",
    "0420",
    "0421C",
    "0421E",
    "0422Oc",
    "0422Or",
    "0423Oc",
    "0423Or",
    "0424",
    "0425",
    "0426",
    "0427",
    "0428",
    "0429",
    "0430",
    "0431",
    "0432",
    "0433",
    "0434",
    "0435",
    "0436",
    "0437",
    "0438",
    "0439",
    "0440",
    "0441",
    "0442",
    "0443",
    "0444",
    "0445",
    "0446",
    "0447",
    "0448",
    "0449",
    "0450",
    "0451",
    "0452",
    "0453",
    "0454",
    "0455",
    "0456",
    "0457",
    "0458",
    "0459",
    "0460",
    "0461",
    "0462",
    "0463",
    "0464",
    "0465",
    "0466",
    "0467",
    "0468",
    "0469",
    "0470",
    "0471",
    "0472",
    "0473",
    "0474",
    "0475",
    "0476",
    "0477",
    "0478",
    "0479",
    "0479C",
    "0479L",
    "0479F",
    "0479H",
    "0479T",
    "0480",
    "0481",
    "0482",
    "0483",
    "0484",
    "0485",
    "0486",
    "0487",
    "0487O",
    "0488",
    "0489",
    "0490",
    "0491",
    "0492T",
    "0492C",
    "0493"
]

export const gen5IDs = [
    "0494",
    "0495",
    "0496",
    "0497",
    "0498",
    "0499",
    "0500",
    "0501",
    "0502",
    "0503",
    "0504",
    "0505",
    "0506",
    "0507",
    "0508",
    "0509",
    "0510",
    "0511",
    "0512",
    "0513",
    "0514",
    "0515",
    "0516",
    "0517",
    "0518",
    "0519",
    "0520",
    "0521M",
    "0521F",
    "0522",
    "0523",
    "0524",
    "0525",
    "0526",
    "0527",
    "0528",
    "0529",
    "0530",
    "0531",
    "0532",
    "0533",
    "0534",
    "0535",
    "0536",
    "0537",
    "0538",
    "0539",
    "0540",
    "0541",
    "0542",
    "0543",
    "0544",
    "0545",
    "0546",
    "0547",
    "0548",
    "0549",
    "0550R",
    "0550B",
    "0551",
    "0552",
    "0553",
    "0554",
    "0555N",
    "0555T",
    "0556",
    "0557",
    "0558",
    "0559",
    "0560",
    "0561",
    "0562",
    "0563",
    "0564",
    "0565",
    "0566",
    "0567",
    "0568",
    "0569",
    "0570",
    "0571",
    "0572",
    "0573",
    "0574",
    "0575",
    "0576",
    "0577",
    "0578",
    "0579",
    "0580",
    "0581",
    "0582",
    "0583",
    "0584",
    "0585P",
    "0585E",
    "0585A",
    "0585H",
    "0586P",
    "0586E",
    "0586A",
    "0586H",
    "0587",
    "0588",
    "0589",
    "0590",
    "0591",
    "0592M",
    "0592F",
    "0593M",
    "0593F",
    "0594",
    "0595",
    "0596",
    "0597",
    "0598",
    "0599",
    "0600",
    "0601",
    "0602",
    "0603",
    "0604",
    "0605",
    "0606",
    "0607",
    "0608",
    "0609",
    "0610",
    "0611",
    "0612",
    "0613",
    "0614",
    "0615",
    "0616",
    "0617",
    "0618",
    "0619",
    "0620",
    "0621",
    "0622",
    "0623",
    "0624",
    "0625",
    "0626",
    "0627",
    "0628",
    "0629",
    "0630",
    "0631",
    "0632",
    "0633",
    "0634",
    "0635",
    "0636",
    "0637",
    "0638",
    "0639",
    "0640",
    "0641A",
    "0641T",
    "0642A",
    "0642T",
    "0643",
    "0644",
    "0645A",
    "0645T",
    "0646",
    "0646B",
    "0646N",
    "0647",
    "0647D",
    "0648C",
    "0648D",
    "0649"
]

export const gen6IDs = [
    "0003ME",
    "0009ME",
    "0015ME",
    "0025C",
    "0025CR",
    "0025CL",
    "0025CS",
    "0025CD",
    "0025CC",
    "0018ME",
    "0065ME",
    "0080ME",
    "0094ME",
    "0115ME",
    "0127ME",
    "0130ME",
    "0142ME",
    "0181ME",
    "0208ME",
    "0212ME",
    "0214ME",
    "0229ME",
    "0248ME",
    "0254ME",
    "0257ME",
    "0260ME",
    "0282ME",
    "0302ME",
    "0303ME",
    "0306ME",
    "0308ME",
    "0310ME",
    "0319ME",
    "0323ME",
    "0334ME",
    "0354ME",
    "0359ME",
    "0362ME",
    "0373ME",
    "0376ME",
    "0380ME",
    "0381ME",
    "0382P",
    "0383P",
    "0384ME",
    "0428ME",
    "0445ME",
    "0448ME",
    "0460ME",
    "0475ME",
    "0493Fee",
    "0531ME",
    "0650",
    "0651",
    "0652",
    "0653",
    "0654",
    "0655",
    "0656",
    "0657",
    "0658",
    "0659",
    "0660",
    "0661",
    "0662",
    "0663",
    "0664",
    "0665",
    "0666Flo",
    "0667",
    "0668M",
    "0668F",
    "0669R",
    "0670R",
    "0671R",
    "0672",
    "0673",
    "0674",
    "0675",
    "0676",
    "0677",
    "0678M",
    "0678F",
    "0679",
    "0680",
    "0681P",
    "0681A",
    "0682",
    "0683",
    "0684",
    "0685",
    "0686",
    "0687",
    "0688",
    "0689",
    "0690",
    "0691",
    "0692",
    "0693",
    "0694",
    "0695",
    "0696",
    "0697",
    "0698",
    "0699",
    "0700",
    "0701",
    "0702",
    "0703",
    "0704",
    "0705",
    "0706",
    "0707",
    "0708",
    "0709",
    "0710",
    "0711",
    "0712",
    "0713",
    "0714",
    "0715",
    "0716D",
    "0717",
    "0718F50",
    "0719",
    "0719ME",
    "0720E",
    "0720D",
    "0721",
    "0006MX",
    "0006MY",
    "0150MX",
    "0150MY"
]

export const gen7IDs = [
    "0019A",
    "0020A",
    "0025HA",
    "0026A",
    "0027A",
    "0028A",
    "0037A",
    "0038A",
    "0050A",
    "0051A",
    "0052A",
    "0053A",
    "0074A",
    "0075A",
    "0076A",
    "0088A",
    "0089A",
    "0103A",
    "0105A",
    "0658S",
    "0718F10",
    "0718P",
    "0722",
    "0723",
    "0724",
    "0725",
    "0726",
    "0727",
    "0728",
    "0729",
    "0730",
    "0731",
    "0732",
    "0733",
    "0734",
    "0735",
    "0736",
    "0737",
    "0738",
    "0739",
    "0740",
    "0741F",
    "0741P",
    "0741H",
    "0741B",
    "0742",
    "0743",
    "0744",
    "0745D",
    "0745N",
    "0745C",
    "0746S",
    "0746B",
    "0747",
    "0748",
    "0749",
    "0750",
    "0751",
    "0752",
    "0753",
    "0754",
    "0755",
    "0756",
    "0757",
    "0758",
    "0759",
    "0760",
    "0761",
    "0762",
    "0763",
    "0764",
    "0765",
    "0766",
    "0767",
    "0768",
    "0769",
    "0770",
    "0771",
    "0772",
    "0773Nor",
    "0774",
    "0774R",
    "0775",
    "0776",
    "0777",
    "0778",
    "0778D",
    "0779",
    "0780",
    "0781",
    "0782",
    "0783",
    "0784",
    "0785",
    "0786",
    "0787",
    "0788",
    "0789",
    "0790",
    "0791",
    "0792",
    "0793",
    "0794",
    "0795",
    "0796",
    "0797",
    "0798",
    "0799",
    "0800",
    "0800CC",
    "0800AA",
    "0800U",
    "0801",
    "0802",
    "0803",
    "0804",
    "0805",
    "0806",
    "0807",
    "0808",
    "0809",
]

export const gen8IDs = [
    "0003Giga",
    "0006Giga",
    "0009Giga",
    "0012Giga",
    "0025Giga",
    "0052Giga",
    "0052G",
    "0058H",
    "0059H",
    "0068Giga",
    "0077G",
    "0078G",
    "0079G",
    "0080G",
    "0083G",
    "0094Giga",
    "0099Giga",
    "0100H",
    "0101H",
    "0110G",
    "0122G",
    "0131Giga",
    "0133Giga",
    "0143Giga",
    "0144G",
    "0145G",
    "0146G",
    "0157H",
    "0199G",
    "0211H",
    "0215H",
    "0222G",
    "0263G",
    "0264G",        
    "0483O",
    "0484O",
    "0503H",
    "0549H",
    "0550W",
    "0554G",
    "0555GN",
    "0555GT",
    "0562G",
    "0569Giga",
    "0570H",
    "0571H",
    "0618G",
    "0628H",
    "0705H",
    "0706H",
    "0713H",
    "0724H",
    "0801P",
    "0809Giga",
    "0810",
    "0811",
    "0812",
    "0812Giga",
    "0813",
    "0814",
    "0815",
    "0815Giga",
    "0816",
    "0817",
    "0818",
    "0818Giga",
    "0819",
    "0820",
    "0821",
    "0822",
    "0823",
    "0823Giga",
    "0824",
    "0825",
    "0826",
    "0826Giga",
    "0827",
    "0828",
    "0829",
    "0830",
    "0831",
    "0832",
    "0833",
    "0834",
    "0834Giga",
    "0835",
    "0836",
    "0837",
    "0838",
    "0839",
    "0839Giga",
    "0840",
    "0841",
    "0841Giga",
    "0842",
    "0842Giga",
    "0843",
    "0844",
    "0844Giga",
    "0845",
    "0845T",
    "0845C",
    "0846",
    "0847",
    "0848",
    "0849A",
    "0849G",
    "0849Giga",
    "0850",
    "0851",
    "0851Giga",
    "0852",
    "0853",
    "0854C",
    "0854A",
    "0855C",
    "0855A",
    "0856",
    "0857",
    "0858",
    "0858Giga",
    "0859",
    "0860",
    "0861",
    "0861Giga",
    "0862",
    "0863",
    "0864",
    "0865",
    "0866",
    "0867",
    "0868",
    "0869VanFra",
    "0869Giga",
    "0870",
    "0871",
    "0872",
    "0873",
    "0874",
    "0875G",
    "0875D",
    "0876M",
    "0876F",
    "0877R",
    "0877A",
    "0878",
    "0879",
    "0879Giga",
    "0880",
    "0881",
    "0882",
    "0883",
    "0884",
    "0884Giga",
    "0885",
    "0886",
    "0887",
    "0888HA",
    "0888ES",
    "0889HA",
    "0889BS",
    "0890",
    "0890I",
    "0891",
    "0892PF",
    "0892MP",
    "0892GigaPF",
    "0892GigaMP",
    "0893",
    "0893P",
    "0894",
    "0895",
    "0896",
    "0897",
    "0898",
    "0898F",
    "0898E",
    "0899",
    "0900",
    "0901",
    "0902M",
    "0902F",
    "0903",
    "0904",
    "0905A",
    "0905T",
]

export const gen9IDs = [
    "0036ME",
    "0071ME",
    "0121ME",
    "0149ME",
    "0154ME",
    "0160ME",
    "0227ME",
    "0358ME",
    "0398ME",
    "0478ME",
    "0485ME",
    "0491ME",
    "0500ME",
    "0530ME",
    "0545ME",
    "0560ME",
    "0604ME",
    "0609ME",
    "0623ME",
    "0652ME",
    "0655ME",
    "0658ME",
    "0668ME",
    "0670ME",
    "0678ME",
    "0687ME",
    "0689ME",
    "0691ME",
    "0701ME",
    "0718ME",
    "0740ME",
    "0768ME",
    "0780ME",
    "0801ME",
    "0801MEP",
    "0807ME",
    "0870ME",
    "0128PC",
    "0128PF",
    "0128PA",
    "0194P",
    "0906",
    "0907",
    "0908",
    "0909",
    "0910",
    "0911",
    "0912",
    "0913",
    "0914",
    "0915",
    "0916M",
    "0916F",
    "0917",
    "0918",
    "0919",
    "0920",
    "0921",
    "0922",
    "0923",
    "0924",
    "0925F3",
    "0925F4",
    "0926",
    "0927",
    "0928",
    "0929",
    "0930",
    "0931V",
    "0931B",
    "0931J",
    "0931W",
    "0932",
    "0933",
    "0934",
    "0935",
    "0936",
    "0937",
    "0938",
    "0939",
    "0940",
    "0941",
    "0942",
    "0943",
    "0944",
    "0945",
    "0946",
    "0947",
    "0948",
    "0949",
    "0950",
    "0951",
    "0952",
    "0952ME",
    "0953",
    "0954",
    "0955",
    "0956",
    "0957",
    "0958",
    "0959",
    "0960",
    "0961",
    "0962",
    "0963",
    "0964O",
    "0964S",
    "0965",
    "0966",
    "0967",
    "0968",
    "0969",
    "0970",
    "0970ME",
    "0971",
    "0972",
    "0973",
    "0974",
    "0975",
    "0976",
    "0977",
    "0978C",
    "0978A",
    "0978R",
    "0978MEC",
    "0978MEA",
    "0978MER",
    "0979",
    "0980",
    "0981",
    "0982F2",
    "0982F3",
    "0983",
    "0984",
    "0985",
    "0986",
    "0987",
    "0988",
    "0989",
    "0990",
    "0991",
    "0992",
    "0993",
    "0994",
    "0995",
    "0996",
    "0997",
    "0998",
    "0998ME",
    "0999C",
    "0999M",
    "1000",
    "1001",
    "1002",
    "1003",
    "1004",
    "1005",
    "1006",
    "1007",
    "1007F",
    "1008",
    "1008U",
    "1009",
    "1010",
    "1011",
    "1012I",
    "1012O",
    "1013M",
    "1013E",
    "1014",
    "1015",
    "1016",
    "1017Tur",
    "1017Pui",
    "1017Fou",
    "1017Pie",
    "1018",
    "1019",
    "1020",
    "1021",
    "1022",
    "1023",
    "1024",
    "1024T",
    "1024S",
    "1025",
    "0026MX",
    "0026MY",
    "0359MZ",
    "0445MZ",
    "0448MZ",
]

export const gen10IDs = [
    "1026",
    "1029",
    "1032",
    "0025F",
    "0025T"
]

export const pikachuFormsIDs = [
    "0025",
    "0025C",
    "0025CR",
    "0025CL",
    "0025CS",
    "0025CD",
    "0025CC",
    "0025HO",
    "0025HH",
    "0025HS",
    "0025HU",
    "0025HK",
    "0025HA",
    "0025HP",
    "0025HM",
    "0025Giga",
    "0025T",
    "0025F"
]

export const pikachuClonesIDs = [
    "0025",
    "0026",
    "0172",
    "0311",
    "0312",
    "0417",
    "0587",
    "0702",
    "0777",
    "0877R",
    "0877A",
    "0921",
    "0922",
    "0923",
]

export const megaIDs = [
    "0003ME",
    "0006MX",
    "0006MY",
    "0009ME",
    "0015ME",
    "0018ME",
    "0026MX",
    "0026MY",
    "0036ME",
    "0065ME",
    "0071ME",
    "0080ME",
    "0094ME",
    "0115ME",
    "0121ME",
    "0127ME",
    "0130ME",
    "0142ME",
    "0149ME",
    "0150MX",
    "0150MY",
    "0154ME",
    "0160ME",
    "0181ME",
    "0208ME",
    "0212ME",
    "0214ME",
    "0227ME",
    "0229ME",
    "0248ME",
    "0254ME",
    "0257ME",
    "0260ME",
    "0282ME",
    "0302ME",
    "0303ME",
    "0306ME",
    "0308ME",
    "0310ME",
    "0319ME",
    "0323ME",
    "0334ME",
    "0354ME",
    "0358ME",
    "0359ME",
    "0359MZ",
    "0362ME",
    "0373ME",
    "0376ME",
    "0380ME",
    "0381ME",
    "0384ME",
    "0398ME",
    "0428ME",
    "0445ME",
    "0445MZ",
    "0448ME",
    "0448MZ",
    "0460ME",
    "0475ME",
    "0478ME",
    "0485ME",
    "0491ME",
    "0500ME",
    "0530ME",
    "0531ME",
    "0545ME",
    "0560ME",
    "0604ME",
    "0609ME",
    "0623ME",
    "0652ME",
    "0655ME",
    "0658ME",
    "0668ME",
    "0670ME",
    "0678ME",
    "0687ME",
    "0689ME",
    "0691ME",
    "0701ME",
    "0718ME",
    "0719ME",
    "0740ME",
    "0768ME",
    "0780ME",
    "0801ME",
    "0801MEP",
    "0807ME",
    "0870ME",
    "0952ME",
    "0970ME",
    "0978MEC",
    "0978MEA",
    "0978MER",
    "0998M",
]

export const arceusIDs = [
    "0493",
    "0493Com",
    "0493Vol",
    "0493Poi",
    "0493Sol",
    "0493Roc",
    "0493Ins",
    "0493Spe",
    "0493Aci",
    "0493Feu",
    "0493Eau",
    "0493Pla",
    "0493Ele",
    "0493Psy",
    "0493Gla",
    "0493Dra",
    "0493Ten",
    "0493Fee"
]

export const silvallieIDs = [
    "0773Nor",
    "0773Com",
    "0773Vol",
    "0773Poi",
    "0773Sol",
    "0773Roc",
    "0773Ins",
    "0773Spe",
    "0773Aci",
    "0773Feu",
    "0773Eau",
    "0773Pla",
    "0773Ele",
    "0773Psy",
    "0773Gla",
    "0773Dra",
    "0773Ten",
    "0773Fee",
]

export const charmillyIDs = [
    "0869VanFra",
    "0869VanBai",
    "0869VanCoe",
    "0869VanEto",
    "0869VanTre",
    "0869VanFle",
    "0869VanRub",
    "0869RubFra",
    "0869RubBai",
    "0869RubCoe",
    "0869RubEto",
    "0869RubTre",
    "0869RubFle",
    "0869RubRub",
    "0869MatFra",
    "0869MatBai",
    "0869MatCoe",
    "0869MatEto",
    "0869MatTre",
    "0869MatFle",
    "0869MatRub",
    "0869MenFra",
    "0869MenBai",
    "0869MenCoe",
    "0869MenEto",
    "0869MenTre",
    "0869MenFle",
    "0869MenRub",
    "0869CitFra",
    "0869CitBai",
    "0869CitCoe",
    "0869CitEto",
    "0869CitTre",
    "0869CitFle",
    "0869CitRub",
    "0869SalFra",
    "0869SalBai",
    "0869SalCoe",
    "0869SalEto",
    "0869SalTre",
    "0869SalFle",
    "0869SalRub",
    "0869MruFra",
    "0869MruBai",
    "0869MruCoe",
    "0869MruEto",
    "0869MruTre",
    "0869MruFle",
    "0869MruRub",
    "0869McaFra",
    "0869McaBai",
    "0869McaCoe",
    "0869McaEto",
    "0869McaTre",
    "0869McaFle",
    "0869McaRub",
    "0869MtrFra",
    "0869MtrBai",
    "0869MtrCoe",
    "0869MtrEto",
    "0869MtrTre",
    "0869MtrFle",
    "0869MtrRub",
]

export const alolaIDs = [
    "0019A",
    "0020A",
    "0026A",
    "0027A",
    "0028A",
    "0037A",
    "0038A",
    "0050A",
    "0051A",
    "0052A",
    "0053A",
    "0074A",
    "0075A",
    "0076A",
    "0088A",
    "0089A",
    "0103A",
    "0105A"
]

export const galarIDs = [
    "0052G",
    "0077G",
    "0078G",
    "0079G",
    "0080G",
    "0083G",
    "0110G",
    "0122G",
    "0144G",
    "0145G",
    "0146G",
    "0199G",
    "0222G",
    "0263G",
    "0264G",
    "0554G",
    "0555GN",
    "0555GT",
    "0562G",
    "0618G"
]

export const hisuiIDs = [
    "0058H",
    "0059H",
    "0100H",
    "0101H",
    "0157H",
    "0211H",
    "0215H",
    "0503H",
    "0549H",
    "0570H",
    "0571H",
    "0628H",
    "0705H",
    "0706H",
    "0713H",
    "0724H"
]

export const paldeaIDs = [
    "0128PC",
    "0128PF",
    "0128PA",
    "0194P"
]

export const regionalIDs = [
    
    "0019A",
    "0020A",
    "0026A",
    "0027A",
    "0028A",
    "0037A",
    "0038A",
    "0050A",
    "0051A",
    "0052A",
    "0053A",
    "0074A",
    "0075A",
    "0076A",
    "0088A",
    "0089A",
    "0103A",
    "0105A",
    "0052G",
    "0077G",
    "0078G",
    "0079G",
    "0080G",
    "0083G",
    "0110G",
    "0122G",
    "0144G",
    "0145G",
    "0146G",
    "0199G",
    "0222G",
    "0263G",
    "0264G",
    "0554G",
    "0555GN",
    "0555GT",
    "0562G",
    "0618G",
    "0058H",
    "0059H",
    "0100H",
    "0101H",
    "0157H",
    "0211H",
    "0215H",
    "0503H",
    "0549H",
    "0570H",
    "0571H",
    "0628H",
    "0705H",
    "0706H",
    "0713H",
    "0724H",
    "0128PC",
    "0128PF",
    "0128PA",
    "0194P"
]

export const legendaryIDs = [
    "0144",
    "0144G",
    "0146",
    "0146G",
    "0150",
    "0150MX",
    "0150MY",
    "0243",
    "0244",
    "0245",
    "0249",
    "0249XD001",
    "0250",
    "0377",
    "0378",
    "0379",
    "0380",
    "0380ME",
    "0381",
    "0381ME",
    "0382",
    "0382P",
    "0383",
    "0383P",
    "0384",
    "0384ME",
    "0480",
    "0481",
    "0482",
    "0483",
    "0483O",
    "0484",
    "0484O",
    "0485",
    "0485ME",
    "0486",
    "0487",
    "0487O",
    "0488",
    "0638",
    "0639",
    "0640",
    "0641A",
    "0641T",
    "0642A",
    "0642T",
    "0643",
    "0644",
    "0645A",
    "0645T",
    "0646",
    "0646B",
    "0646N",
    "0716",
    "0716D",
    "0717",
    "0718F10",
    "0718F50",
    "0718P",
    "0718ME",
    "0785",
    "0786",
    "0787",
    "0788",
    "0789",
    "0790",
    "0791",
    "0792",
    "0800",
    "0800CC",
    "0800AA",
    "0800U",
    "0888HA",
    "0888ES",
    "0889HA",
    "0889BS",
    "0890",
    "0890I",
    "0891",
    "0892PF",
    "0892MP",
    "0892GigaPF",
    "0892GigaMP",
    "0894",
    "0895",
    "0896",
    "0897",
    "0898",
    "0898F",
    "0898E",
    "0905A",
    "0905T",
    "1001",
    "1003",
    "1004",
    "1007",
    "1007F",
    "1008",
    "1008U",
    "1014",
    "1015",
    "1016",
    "1017Tur",
    "1017Pui",
    "1017Fou",
    "1017Pie",
    "1024",
    "1024T",
    "1024S"
]

export const fabulousIDs = [
    "0151",
    "0251",
    "0385",
    "0386",
    "0386A",
    "0386D",
    "0386V",
    "0489",
    "0490",
    "0491",
    "0491ME",
    "0492T",
    "0492C",
    "0493",
    "0494",
    "0647",
    "0647D",
    "0648C",
    "0648D",
    "0649",
    "0719",
    "0719ME",
    "0720E",
    "0720D",
    "0721",
    "0801",
    "0801P",
    "0801ME",
    "0801MEP",
    "0802",
    "0807",
    "0807ME",
    "0808",
    "0809",
    "0809Giga",
    "0893",
    "0893P",
    "1025"
]

export const legendaryFabulousIDs = [
    "0144",
    "0144G",
    "0146",
    "0146G",
    "0150",
    "0150MX",
    "0150MY",
    "0243",
    "0244",
    "0245",
    "0249",
    "0249XD001",
    "0250",
    "0377",
    "0378",
    "0379",
    "0380",
    "0380ME",
    "0381",
    "0381ME",
    "0382",
    "0382P",
    "0383",
    "0383P",
    "0384",
    "0384ME",
    "0480",
    "0481",
    "0482",
    "0483",
    "0483O",
    "0484",
    "0484O",
    "0485",
    "0485ME",
    "0486",
    "0487",
    "0487O",
    "0488",
    "0638",
    "0639",
    "0640",
    "0641A",
    "0641T",
    "0642A",
    "0642T",
    "0643",
    "0644",
    "0645A",
    "0645T",
    "0646",
    "0646B",
    "0646N",
    "0716",
    "0716D",
    "0717",
    "0718F10",
    "0718F50",
    "0718P",
    "0718ME",
    "0785",
    "0786",
    "0787",
    "0788",
    "0789",
    "0790",
    "0791",
    "0792",
    "0800",
    "0800CC",
    "0800AA",
    "0800U",
    "0888HA",
    "0888ES",
    "0889HA",
    "0889BS",
    "0890",
    "0890I",
    "0891",
    "0892PF",
    "0892MP",
    "0892GigaPF",
    "0892GigaMP",
    "0894",
    "0895",
    "0896",
    "0897",
    "0898",
    "0898F",
    "0898E",
    "0905A",
    "0905T",
    "1001",
    "1003",
    "1004",
    "1007",
    "1007F",
    "1008",
    "1008U",
    "1014",
    "1015",
    "1016",
    "1017Tur",
    "1017Pui",
    "1017Fou",
    "1017Pie",
    "1024",
    "1024T",
    "1024S",
    "0151",
    "0251",
    "0385",
    "0386",
    "0386A",
    "0386D",
    "0386V",
    "0489",
    "0490",
    "0491",
    "0491ME",
    "0492T",
    "0492C",
    "0493",
    "0494",
    "0647",
    "0647D",
    "0648C",
    "0648D",
    "0649",
    "0719",
    "0719ME",
    "0720E",
    "0720D",
    "0721",
    "0801",
    "0801P",
    "0801ME",
    "0801MEP",
    "0802",
    "0807",
    "0807ME",
    "0808",
    "0809",
    "0809Giga",
    "0893",
    "0893P",
    "1025"
]

export const prismillonIDs = [
    "0666Bli",
    "0666Ban",
    "0666Gla",
    "0666Con",
    "0666Ver",
    "0666Mon",
    "0666Flo",
    "0666Met",
    "0666Riv",
    "0666Arc",
    "0666Sec",
    "0666Sab",
    "0666Del",
    "0666Cyc",
    "0666Man",
    "0666Zen",
    "0666Sle",
    "0666Jun",
    "0666Fan",
    "0666Pba"
]

export const gigamaxIDs = [
    "0003Giga",
    "0006Giga",
    "0009Giga",
    "0012Giga",
    "0025Giga",
    "0052Giga",
    "0068Giga",
    "0094Giga",
    "0099Giga",
    "0131Giga",
    "0133Giga",
    "0143Giga",
    "0569Giga",
    "0809Giga",
    "0812Giga",
    "0815Giga",
    "0818Giga",
    "0823Giga",
    "0826Giga",
    "0834Giga",
    "0839Giga",
    "0841Giga",
    "0842Giga",
    "0844Giga",
    "0849Giga",
    "0851Giga",
    "0858Giga",
    "0861Giga",
    "0869Giga",
    "0879Giga",
    "0884Giga",
    "0892GigaPF",
    "0892GigaMP"
]

export const zarbiIDs = [
    "0201A",
    "0201B",
    "0201C",
    "0201D",
    "0201E",
    "0201F",
    "0201G",
    "0201H",
    "0201I",
    "0201J",
    "0201K",
    "0201L",
    "0201M",
    "0201N",
    "0201O",
    "0201P",
    "0201Q",
    "0201R",
    "0201S",
    "0201T",
    "0201U",
    "0201V",
    "0201W",
    "0201X",
    "0201Y",
    "0201Z",
    "0201PI",
    "0201PE"
]

export const metenoIDs = [
    "0774R",
    "0774O",
    "0774J",
    "0774G",
    "0774B",
    "0774I",
    "0774V"
]

export const ultraBeastsIDs = [
    "0789",
    "0790",
    "0791",
    "0792",
    "0793",
    "0794",
    "0795",
    "0796",
    "0797",
    "0798",
    "0799",
    "0800",
    "0803",
    "0804",
    "0805",
    "0806",
]

export const paradoxIDs = [
    "0984",
    "0985",
    "0986",
    "0987",
    "0988",
    "0989",
    "0990",
    "0991",
    "0992",
    "0993",
    "0994",
    "0095",
    "1005",
    "1006",
    "1007F",
    "1008U",
    "1009",
    "1010",
    "1020",
    "1021",
    "1022",
    "1023",
]